import { RedTheme, BlueTheme } from 'common/global';
import { useSelector } from 'react-redux';
/**
* SelectedTheme.
* @returns {object}
*/
export const SelectedTheme = () => {
    const theme = [RedTheme, BlueTheme];
    let getThemeFromState = useSelector((state) => {
        return state.themeSwitcherRd;
    });
    const themeSelected =
        getThemeFromState && getThemeFromState.selectedTheme?.themeType
            ? theme[getThemeFromState.selectedTheme.themeType]
            : theme[0];

    return themeSelected

}